import { Typography } from '@one-thd/sui-atomic-components';
import { Location } from '@one-thd/sui-icons';
import { getPersonName } from '../../utils/order-details';
import { CityStateZipLine } from './CityStateZipLine';
import { IShippingAndHandling } from '../../models/order-details';

interface IDeliveryAddressDetails {
  shippingAndHandling?: IShippingAndHandling | null;
}

export const DeliveryAddressDetails = ({ shippingAndHandling }: IDeliveryAddressDetails) => {
  const deliveryAddress = shippingAndHandling?.deliveryAddress;

  if (!deliveryAddress) {
    return null;
  }

  const postal = deliveryAddress?.postalDetails;
  /** Undefined when the payload sent no name, so the line is omitted, not blank. */
  const recipientName = getPersonName(deliveryAddress?.name);

  return (
    <div className="sui-flex sui-p-4" data-testid="delivery-address-details">
      <div className="sui-flex sui-flex-row sui-gap-4 sui-pl-2">
        <span className="sui-mt-1">
          <Location size="small" />
        </span>

        <div>
          <Typography variant="h6">Delivery Address</Typography>

          {recipientName && (
            <Typography variant="body-sm">
              {recipientName}
            </Typography>
          )}

          <Typography variant="body-sm" data-testid="address-line-1">
            {postal?.addressLine1}
          </Typography>

          {postal?.addressLine2 && (
            <Typography variant="body-sm" data-testid="address-line-2">
              {postal?.addressLine2}
            </Typography>
          )}

          <CityStateZipLine
            city={postal?.city}
            state={postal?.state}
            zipCode={postal?.zipCode}
          />
        </div>
      </div>
    </div>
  );
};
